// Lightweight loading skeletons used while data loads.
export const StatSkeleton = () => (
  <div className="bg-white border border-[#E7E7E2] rounded-2xl p-7 md:p-8 min-h-[160px] animate-pulse">
    <div className="h-3 w-20 bg-[#E7E7E2] rounded" />
    <div className="mt-6 h-12 w-32 bg-[#E7E7E2] rounded" />
    <div className="mt-auto pt-6 h-3 w-44 bg-[#E7E7E2] rounded" />
  </div>
);

export const RowSkeleton = ({ cols = 3 }) => (
  <tr className="border-b border-[#E7E7E2] last:border-b-0 animate-pulse">
    {Array.from({ length: cols }).map((_, i) => (
      <td key={i} className="px-5 py-5">
        <div className="h-3 w-32 bg-[#E7E7E2] rounded" />
      </td>
    ))}
    <td className="px-5 py-5" />
  </tr>
);
